/**
 * Properties carried on each fitting GeoJSON feature, as projected by the backend
 * `waterfittings/md/{bbox}` endpoint. Only these two fields are available.
 */
export interface FittingFeatureProperties {
    id: string;
    fittingType: number | null;
}

// Labels for the numeric `fittingType` enum (WaterFittingTypes in CommonApi.Enums).
// Preserved here now that fittings render as a uniform marker and no longer encode their
// type via the marker colour.
const FITTING_TYPE_LABELS: Readonly<Record<number, string>> = {
    0: 'Unknown',
    1: 'Hydrant',
    2: 'Air Valve',
    3: 'Meter',
    4: 'Valve',
    5: 'Boundary Box',
};

/**
 * Returns a friendly display label for a fitting's numeric `fittingType`. Null, undefined
 * or unrecognised values fall back to 'Unknown' so the tooltip always shows something.
 */
export function formatFittingType(fittingType: number | null | undefined): string {
    if (fittingType == null) return 'Unknown';
    return FITTING_TYPE_LABELS[fittingType] ?? 'Unknown';
}
